import React, { useEffect, useState, Fragment, useRef} from 'react';

import fuwuneirong from 'images/kangyang/fuwuneirong@2x.png';
import styles from './index.module.scss';
import { BottomButton } from "./components/bottomButton";
import { IntentionCommit } from './components/intentionCommit';
import { Slogon } from '../../slogon';
import { Actions } from 'reduxs';
import services from 'services';
import Library from 'library';
import { umengTrack_healthcare } from 'library/jsbridge/config';
import { Header } from 'components';
import { YSJDetail } from '../ysjdetail';
import { GridView } from './components/GridView';
import { VideoGrid } from './components/videoGrid';
import { Introduce }  from './components/Introduce';
import { BottomButton2 } from './components/bottomButton2';
import { ImgTxtList } from './components/ImgTxtList';
const {JsBridge, Platform} = Library;

const Tabs = [
    [{ name: '介绍', type: 0 },{ name: '沂鑫卡', type: 4 },{ name: '视频', type: 1 },{ name: '图文', type: 5}],
    [{ name: '康养居', type: 2 }, { name: '服务内容', type: 3 }],
]
// const Tabs = [
//     [{ name: '介绍', type: 0 },{ name: '沂鑫卡', type: 4 },{ name: '视频', type: 1 }],
//     [{ name: '康养居', type: 2 }, { name: '服务内容', type: 3 }],
// ]

export const KangYangJu = (props) => {
    const {segment, index} = Library.Util.url.paramsToObj();
    console.log(`segment:${segment}`, `index:${index}`);

    const [segmentIndex, setSegmentIndex] = useState(segment&&+segment < Tabs.length ? +segment: 0);
    const [tabIndex, setTabIndex] = useState(index && +index < Tabs[0].length  ? +index :0);

    const [visible, setVisible] = useState(false);
    const [arrSource, setArrSource] = useState([]);
    const [arrVideo, setArrVideo] = useState([]);
    const [arrImgTxt,setArrImgTxt] = useState([]);
    const [hasMore, setHasMore] = useState(false);
    const [loading, setLoading] = useState(true);
    const currentPage = useRef(1);

    const [videoDot, setVideoDot] = useState(false);

    
    
    

    useEffect(()=>{
        getVideoDot();
    },[])

    useEffect(() => {
        console.log("2222222222222222222")
        if((segment || index) && arrVideo.length > 0) {
            setVideoDot(false);
        }
        loadData() 
    }, [segmentIndex, tabIndex])

    const loadData = async () => {
        if(segmentIndex === 1) {
            if (tabIndex === 0 && arrSource.length === 0) {
                window.scrollTo({ top: 0.1 });//如果滚动后进入其他页面再返回会导致tab栏显示不了，需要滚动让tab栏显示出来
                getData()
            }
        }else {
            if(tabIndex === 2 && arrVideo.length === 0){
                setVideoDot(false);
                await onRefreshVideo();
            }
            if(tabIndex === 3 && arrImgTxt.length === 0){
                await onRefreshimgTxt();
                // const list = [{
                //         "articleUpdateTime": "2023-12-08 10:33:41",
                //         "id": 27,
                //         "title": "1111111",
                //         "url": "www&?"
                //     }, {
                //         "articleUpdateTime": "2023-12-08 10:28:38",
                //         "id": 26,
                //         "title": "yyyyy",
                //         "url": "&"
                //     }, {
                //         "articleUpdateTime": "2023-12-07 14:40:00",
                //         "id": 23,
                //         "title": "定时十四点四十",
                //         "url": "http://mp.weixin.qq.com/s?__biz=MzI3NjI5MzU4Ng==&amp;mid=2247496590&amp;idx=1&amp;sn=e164b3c6c756eec9a212cdfd6d937543&amp;chksm=eb750133dc02882539f8f420b465c8af04ad6744d387830ecf95f10c41947f0922fdd6e58db1#rd"
                //     }, {
                //         "articleUpdateTime": "2023-12-07 14:36:23",
                //         "id": 22,
                //         "title": "围观覅u歌舞i给覅我给采购i我从不为",
                //         "url": "http://mp.weixin.qq.com/s?__biz=MzI3NjI5MzU4Ng==&amp;mid=2247496590&amp;idx=1&amp;sn=e164b3c6c756eec9a212cdfd6d937543&amp;chksm=eb750133dc02882539f8f420b465c8af04ad6744d387830ecf95f10c41947f0922fdd6e58db1#rd"
                //     }, {
                //         "articleUpdateTime": "2023-12-05 19:17:51",
                //         "id": 13,
                //         "title": "真理既是美的，美也是真理的。",
                //         "url": "https://android.myapp.com/myapp/detail.htm?https://mp.weixin.qq.com/s/fxIPU1ejbYIX-tqReKqmSA"
                //     }, {
                //         "articleUpdateTime": "2023-12-05 17:17:49",
                //         "id": 11,
                //         "title": "无知带来自信，智慧带来怀疑。",
                //         "url": "https://android.myapp.com/myapp/detail.htm?https://mp.weixin.qq.com/s/fxIPU1ejbYIX-tqReKqmSA"
                //     }, {
                //         "articleUpdateTime": "2023-12-05 16:17:48",
                //         "id": 10,
                //         "title": "我们的选择塑造了我们的命运。",
                //         "url": "https://android.myapp.com/myapp/detail.htm?https://mp.weixin.qq.com/s/fxIPU1ejbYIX-tqReKqmSA"
                //     }, {
                //         "articleUpdateTime": "2023-12-05 15:17:47",
                //         "id": 9,
                //         "title": "真正的力量来自内心的平静。",
                //         "url": "https://android.myapp.com/myapp/detail.htm?https://mp.weixin.qq.com/s/fxIPU1ejbYIX-tqReKqmSA"
                //     }, {
                //         "articleUpdateTime": "2023-12-05 14:18:59",
                //         "id": 21,
                //         "title": "思考是我们与生俱来的权利。",
                //         "url": "https://android.myapp.com/myapp/detail.htm?https://mp.weixin.qq.com/s/fxIPU1ejbYIX-tqReKqmSA"
                //     }, {
                //         "articleUpdateTime": "2023-12-05 14:17:58",
                //         "id": 20,
                //         "title": "我们是宇宙意识的表达。",
                //         "url": "https://android.myapp.com/myapp/detail.htm?https://mp.weixin.qq.com/s/fxIPU1ejbYIX-tqReKqmSA"
                //     }];
                // setArrImgTxt(list)
                // console.log("444444444444444")
                // console.log(arrImgTxt)
            }
        }  
    }

    const getVideoDot = async () => {
        const module = Platform.check.isApp() ? 'MainPage': 'Common'
        const res = await services(module, { code: 101196 }, { }, true);
        if (res.status > 0) {
            const flag = res.data.result || res.data;
            setVideoDot(flag !== true);
        }
    }

    const getData = async () => {
        const result = Platform.check.isApp() ? await services('MainPage', { code: 101149 }, {}) : await services('KangYang', 'List', {});
        if (result.status > 0) {
            let { recuperation, base } = result.data;
            setArrSource(recuperation);
        }
    }

    const getVideoList = async (more)=> {
        const module = Platform.check.isApp() ? 'MainPage': 'Common';
        if(!more){
            currentPage.current = 1;
        }
        const param = {
            type:1,
            pageNum:more ? currentPage.current +1: currentPage.current, 
            pageSize:10 
        }
        const res =  await services(module, { code: 101195 }, param, !loading);
        setLoading(false);
        if (res.status > 0) {
            const list = res.data.result || res.data;
            if(more) {
                setArrVideo([...arrVideo, ...list])
                currentPage.current = currentPage.current + 1
            }else {
                setArrVideo(list);
            }
            setHasMore(list.length >= 10)
        }
    }
    const onRefreshVideo = async ()  => {
        currentPage.current = 1;
       await getVideoList();
    }
    const loadMoreVideo = async ()=> {
       await getVideoList(true);
    }


    const getimgTxtList = async (more)=> {
        // const module = Platform.check.isApp() ? 'MainPage': 'Common';
        if(!more){
            currentPage.current = 1;
        }
        const param = {
            type:'6',
            pageNum:more ? currentPage.current +1: currentPage.current, 
            pageSize:10 
        }
        const res =  await services('MainPage', { code: '100009' }, param, !loading);
        setLoading(false);
        if (res.status > 0) {
            const list = res.data.guHomeOfficeNewsList;
            if(more) {
                setArrImgTxt([...arrImgTxt, ...list])
                currentPage.current = currentPage.current + 1
            }else {
                setArrImgTxt(list);
            }
            setHasMore(list.length >= 10)
        }
    }
    const onRefreshimgTxt = async ()  => {
        currentPage.current = 1;
       await getimgTxtList();
    }
    const loadMoreimgTxt = async ()=> {
       await getimgTxtList(true);
    }

    const renderServerContent = () => {
        return <div className={styles.service_box}>
            <img className={styles.fullImg} src={fuwuneirong} draggable={false}/>
            <Slogon />
        </div>
    }

    const renderHeader = ()=> {
        const segments = ['绿地颐尚居', '康养居酒店'];
        return (
            <div className={styles.header_segment}>
                {
                    segments.map((item, i) => {
                        return (
                            <div className={`${styles.segment} ${segmentIndex ===i ? styles.active:''}`} key={i} 
                                onClick={()=>{
                                    setSegmentIndex(i);
                                    setTabIndex(0);
                                }}
                            >{item}</div>
                        )
                    })
                }
            </div>
        )
    }
    
    const Xijinka = ()=> {
        
        const scrollableRef = useRef(null);
        const [lastScroll,setLastScroll] = useState(0);
        const scrollableElement = scrollableRef?.current;
        const [show2,setShow2] = useState(false)
        const [show,setShow] = useState(false)
        const [num,setNum] = useState(1)

        const handleScroll = () => {
            const scrollTop = scrollableRef.current?.scrollTop;
            console.log("scrollTop:");
            setLastScroll(scrollTop);
            console.log("scrollTop:"+scrollTop);
        };

        useEffect(()=>{
            const scrollableElement = scrollableRef?.current;
            scrollableElement.addEventListener('scroll',handleScroll);

            //页面销毁，移除事件
            return (props) =>{
                scrollableElement.removeEventListener('scroll',handleScroll);
            };
        })

        const ShowModal=(num)=>{
            setNum(num);
            setShow(true);
        }

        return (
            <div className={styles.qijinka} ref={scrollableRef}>
                <div className={styles.container2}>
                    <div className={styles.topBg} draggable={false}/>
                    <div className={styles.title}>
                        中端
                    </div>
                    <div className={styles.line}>
                        <div className={styles.column} onClick={()=>ShowModal(1)}>盐城绿地铂派酒店{show2?1:2}</div>
                        <div className={styles.column} onClick={()=>ShowModal(2)}>上海之鱼绿地铂派酒店</div>
                    </div>
                    <div className={styles.line}>
                        <div className={styles.column} onClick={()=>ShowModal(3)}>宁波杭州湾铂派酒店</div>
                        <div className={styles.column} onClick={()=>ShowModal(4)}>商丘国展绿地铂派酒店</div>
                    </div>
                    <div className={styles.line}>
                        <div className={styles.column} onClick={()=>ShowModal(5)}>上海绿地公馆和绿地 会议中心</div>
                        <div className={styles.column} onClick={()=>ShowModal(6)}>济南雪野湖绿地游邑 精品酒店</div>
                    </div>
                    <div className={styles.line}>
                        <div className={styles.column1} onClick={()=>ShowModal(7)}>济南国博城绿地铂派酒店</div>
                    </div>
                    <div className={styles.title}>
                        铂骊
                    </div>
                    <div className={styles.line}>
                        <div className={styles.column} onClick={()=>ShowModal(8)}>上海浦东绿地铂骊酒店</div>
                        <div className={styles.column} onClick={()=>ShowModal(9)}>徐州东区绿地铂骊酒店</div>
                    </div>
                    <div className={styles.line}>
                        <div className={styles.column} onClick={()=>ShowModal(10)}>赣江新城铂骊酒店</div>
                        <div className={styles.column} onClick={()=>ShowModal(11)}>济南绿地铂骊酒店</div>
                    </div>
                    <div className={styles.line}>
                        <div className={styles.column} onClick={()=>ShowModal(12)}>上海南桥绿地铂骊酒店</div>
                        <div className={styles.column} onClick={()=>ShowModal(13)}>宁波北城绿地铂骊酒店</div>
                    </div>
                    <div className={styles.line}>
                        <div className={styles.column} onClick={()=>ShowModal(14)}>安庆绿地铂骊酒店</div>
                    </div>
                    <div className={styles.title}>
                        铂瑞
                    </div>
                    <div className={styles.line}>
                        <div className={styles.column1} onClick={()=>ShowModal(15)}>沈阳绿地棋盘山铂瑞酒店</div>
                        <div className={styles.column} onClick={()=>ShowModal(16)}>武汉汉南绿地铂瑞酒店</div>
                    </div>
                    <div className={styles.line}>
                        <div className={styles.column2} onClick={()=>ShowModal(17)}>南昌国际博览城绿地铂瑞酒店</div>
                        <div className={styles.column3} onClick={()=>ShowModal(18)}>徐州绿地铂瑞酒店</div>
                    </div>
                    <div className={styles.line}>
                        <div className={styles.column1} onClick={()=>ShowModal(19)}>嘉兴湘家荡绿地铂瑞酒店</div>
                        <div className={styles.column1} onClick={()=>ShowModal(20)}>银川国际交流中心铂瑞酒店</div>
                    </div>
                    <div className={styles.title}>
                        三甲港暇咖岛
                    </div>
                    <div className={styles.line}>
                        <div className={styles.column4} onClick={()=>ShowModal(21)}>上海三甲港滨海绿地铂瑞酒店</div>
                        <div className={styles.column4} onClick={()=>ShowModal(22)}>上海三甲港滨海绿地铂骊酒店</div>
                    </div>
                    <div className={styles.line}>
                        <div className={styles.column2} onClick={()=>ShowModal(23)}>上海三甲港滨海绿地铂派酒店</div>
                    </div>
                    <div className={styles.bottonWhite}></div>
                </div>
                 {
                show?<div className={styles.modal} onClick={()=>setShow(false)}>
                    <div className={
                        num==1?styles.content1:num==2?styles.content2:num==3?styles.content3:
                        num==4?styles.content4:num==5?styles.content5:num==6?styles.content6:
                        num==7?styles.content7:num==8?styles.content8:num==9?styles.content9:
                        num==10?styles.content10:num==11?styles.content11:num==12?styles.content12:
                        num==13?styles.content13:num==14?styles.content14:num==15?styles.content15:
                        num==16?styles.content16:num==17?styles.content17:num==18?styles.content18:
                        num==19?styles.content19:num==20?styles.content20:num==21?styles.content21:
                        num==22?styles.content22:num==23?styles.content23:null
                    }>
                        <div className={styles.cancel} onClick={()=>{
                            setShow(false);
                        }}>
                        </div>
                    </div>
                </div>:null
                }
                
                
            </div>
    
          
        );
    
    }

    


    return <div className={styles.container}>
         <Header midText={renderHeader()} shadow />
        <div className={styles.tabs}>
            {Tabs[segmentIndex].map((item, i) => {
                return <div className={`${styles.item} ${i !== 0 ? styles.line : ''}`} key={i} onClick={() => {
                    if (Platform.check.isApp()) {
                        JsBridge.UmengTrack(umengTrack_healthcare.topic1, item.name);
                    }
                    setTabIndex(i);
                    window.scrollTo({ top: 0.1 });
                }}>
                    <div className={`${styles.textBg}`}>
                        {item.type === 1 && videoDot && <div className={styles.dot}/>} 
                        <span className={`${i === tabIndex ? styles.active : ''}`}>{item.name}</span>
                    </div>
                </div>
            })}
        </div>
        <div className={styles.content}>
        {
            segmentIndex === 0 ?
            <Fragment>
            {tabIndex === 0 ? <Introduce/> :  null}
            {tabIndex === 1 ? <Xijinka/> :  null}
            {tabIndex === 2 ?<VideoGrid list={arrVideo} hasMore={hasMore} onRefresh={onRefreshVideo} loadMore={loadMoreVideo}/>:null}
            {tabIndex === 3 ?<ImgTxtList list={arrImgTxt} hasMore={hasMore} onRefresh={onRefreshimgTxt} loadMore={loadMoreimgTxt} />:  null}
            
            </Fragment>:
            <Fragment>
            {tabIndex === 0 ? <GridView arrSource={arrSource} /> : null}
            {tabIndex === 1 ? renderServerContent() : null}
            </Fragment>
        }
        </div>
        {
            tabIndex === segmentIndex &&
            <Fragment>
            <BottomButton onClick={() => {
                setVisible(true);
            }} />
            <IntentionCommit visible={visible} 
                onHide={(isSuccess) => {
                    setVisible(false);
                    if (isSuccess) {
                        Actions.alert.show('提交意向成功');
                    }
                }}
            />
            </Fragment>
        }
        {
            segmentIndex === 0 &&
            tabIndex === 1 &&
            <Fragment>
            <BottomButton2 onClick={() => {
                setVisible(true);
            }} />
            </Fragment>
        }
        
    </div>
};

